import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Row,
  Col,
  Table,
  Dropdown,
  Button,
  Divider,
  Modal,
  DatePicker,
  MenuProps,
  Image,
  Radio,
  Select,
  Switch,
  UploadProps,
} from "antd";
// import type { MenuProps } from "antd";
import {
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  PrinterOutlined,
  ReloadOutlined,
  FolderOpenOutlined,
  DollarOutlined,
  FilterOutlined,
  CheckOutlined,
  AlertOutlined,
  ContainerOutlined,
  ContainerFilled,
  FileOutlined,
  InboxOutlined,
  ControlFilled,
} from "@ant-design/icons";
import {
  getPurchasesService,
  getSuppliersService,
  getMaterialService,
  getMetalsService,
  postBillService,
  getPurchasePDF,
  deletePurchaseService,
  toggleSmallPurchaseService,
  postUploadPurchaseOutImagesService,
} from "./PurchasesPageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import _ from "lodash";
import Loader from "../../components/Loader/Loader";
import "./PurchasesPage.css";
import { removeTokenFromCookies } from "../../utils/cookies";
import Copyright from "../../components/Copyright/Copyright";
import printJS from "print-js";
import Cookies from "universal-cookie";
import moment from "moment";
import dayjs from "dayjs";
import Dragger from "antd/es/upload/Dragger";
import { message, Upload } from "antd";

const { RangePicker } = DatePicker;
const { Content } = Layout;

export interface PurchasesPageProps {}

const PurchasesPage = (props: PurchasesPageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [purchasesList, setPurchasesList] = useState([]) as any;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPurchases, setTotalPurchases] = useState(0);
  const [suppliers, setSuppliers] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [purchaseToDelete, setPurchaseToDelete] = useState({}) as any;
  const [loading, setLoading] = useState(true);
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [printPurchaseData, setPrintPurchaseData] = useState(null) as any;
  const [purchaseDetailsTableData, setPurchaseDetailsTableData] = useState([]) as any;
  const [metals, setMetals] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [suppliersSelectedOptions, setSuppliersSelectedOptions] = useState("");
  const [dateRangeFilter, setDateRangeFilter] = useState([null, null]) as any;
  const [dateRangeValue, setDateRangeValue] = useState([null, null]) as any;
  const [suppliersOptions, setSuppliersOptions] = useState([]) as any;
  const [isFilteredData, setIsFilteredData] = useState(false);
  const [purchaseOutUploadModal, setPurchaseOutUploadModal] = useState(false);
  const [purchaseOutImagesList, setPurchaseOutImagesList] = useState([]) as any;
  const [purchaseIDForPurchaseOutUpload, setPurchaseIDForPurchaseOutUpload] = useState("");
  const [uploadDisable, setUploadDisable] = useState(false);
  const cookies = new Cookies();
  let navigate = useNavigate();
  const currOffice = cookies.get("CURR_OFFICE");
  const purchaseColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center",
      width: "5%",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Date",
      key: "date",
      align: "center",
      // width: "7.5%",
      render: (record: any) => new Date(record.createdTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Time",
      key: "time",
      align: "center",
      // width: "7.5%",
      render: (record: any) =>
        new Date(record.createdTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    {
      title: "Purchase Out",
      key: "purchaseOut",
      align: "center" as const,
      render: (record: any) =>
        //////check this
        false ? (
          <FileOutlined />
        ) : (
          <Button type="primary" size="small" onClick={() => openPurchaseOutUploadModal(record.purchaseID)}>
            Upload
          </Button>
        ),
    },
    {
      title: "Supplier",
      key: "supplier",
      // width: "20%",
      render: (record: any) => getSupplierDisplayName(record.supplierID),
    },
    {
      title: "Total Net Weight (kg)",
      key: "totalNetWeight",
      align: "center",
      render: (record: any) =>
        record.totalNetWeight ? (
          <strong style={{ marginRight: "10px" }}>{Number(record.totalNetWeight).toFixed(1)}</strong>
        ) : (
          ""
        ),
    },
    {
      title: "Materials Info",
      key: "materials",
      // width: "10%",
      align: "center",
      render: (record: any) => {
        return record.totalNumMaterials
          ? `${record.totalNumMaterials} materials (${record.materialIDList.length} weights)`
          : `${record.materialIDList.length} weights`;
      },
    },
    {
      title: "Transaction Type",
      key: "transactionType",
      align: "center",
      render: (record: any) => {
        return record.smallTransaction ? (
          "Small"
        ) : (
          <>
            <ContainerFilled style={{ marginRight: "5px", color: "#283555" }} />
            Bill
          </>
        );
      },
    },
    {
      title: "Small Purchase",
      key: "smallPurchase",
      align: "center",
      render: (record: any) => {
        return (
          <Switch checked={record.smallTransaction} onChange={(checked: any) => toggleSmallPurchase(record, checked)} />
        );
      },
    },
    Table.EXPAND_COLUMN,
    {
      title: "Purchase Completed",
      dataIndex: "completed",
      key: "completed",
      align: "center",
      // width: "7.5%",
      render: (record: any) =>
        record ? (
          <>
            <CheckOutlined style={{ color: "green", marginRight: "5px" }} /> Yes
          </>
        ) : (
          <>
            <AlertOutlined style={{ color: "orange", marginRight: "5px" }} />
            No
          </>
        ),
    },
    {
      title: "Bill Issued",
      dataIndex: "billIssued",
      key: "billIssued",
      align: "center",
      // width: "7.5%",
      render: (record: any) => (record ? "Yes" : "No"),
    },
    {
      title: "Generate Bill",
      key: "generateBill",
      align: "center",
      // width: "7.5%",
      render: (record: any) =>
        record.completed && !record.billIssued ? (
          <Button type="primary" size="small" onClick={() => generateBill(record.purchaseID, record.supplierID)}>
            Generate Bill
          </Button>
        ) : null,
    },
    // {
    //   title: "Print Purchase",
    //   key: "printPurchase",
    //   align: "center",
    //   width: "10%",
    //   render: (record: any) =>
    //     record.completed ? (
    //       <Button type="primary" size="small" onClick={() => printPurchase(record)} icon={<PrinterOutlined />}>
    //         Print Purchase
    //       </Button>
    //     ) : null,
    // },
    {
      title: "Options",
      key: "options",
      align: "center",
      width: "7.5%",
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        if (record.completed) items.push({ key: "print", label: "Print Purchase", icon: <PrinterOutlined /> });
        record.completed && isTimestampMoreThan2Hours(record.createdTimestamp)
          ? items.push({ key: "edit", label: "View Purchase", icon: <FolderOpenOutlined /> })
          : items.push({ key: "edit", label: "Edit Purchase", icon: <EditOutlined /> });
        if (record.completed && record.billIssued)
          items.push({ key: "bill", label: "View Bill", icon: <DollarOutlined /> });
        if (userRole === "admin")
          items.push({ key: "delete", label: "Delete Purchase", icon: <DeleteOutlined />, style: { color: "red" } });

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") editPurchase(record);
                else if (key === "delete") openDeletePurchaseModal(record);
                else if (key === "print") printPurchase(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const purchaseDetailsColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Images",
      key: "index",
      render: (record: any) => (
        <>
          <Image
            height={50}
            width={50}
            src={record.scaleImageURL || record.imageURL}
            wrapperStyle={{ marginRight: "10px" }}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#000000" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
          <Image
            height={50}
            width={50}
            src={record.materialImageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{record.displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                  <h3 style={{ color: "#000000" }}>Net Weight: {Number(record.netWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
        </>
      ),
      align: "center" as const,
    },
    {
      title: "Material Name",
      dataIndex: "displayName",
      align: "center" as const,
      render: (name: string) => <strong>{name}</strong>,
    },
    {
      title: "Raw Weight (kg)",
      key: "rawWeight",
      // dateIndex: "rawWeight",
      align: "center" as const,
      render: (record: any) => {
        return record ? Number(record.rawWeight).toFixed(1) : null;
      },
    },
    {
      title: "Waste Weight (kg)",
      key: "wasteWeight",
      dateIndex: "wasteWeight",
      align: "center" as const,
      render: (record: any) => {
        if (record === undefined) return;
        let wasteInfo = "(";
        if (record.smallBag > 0) {
          if (record.bigBag > 0) wasteInfo += `${record.smallBag} small, `;
          else wasteInfo += `${record.smallBag} small`;
        }
        if (record.bigBag > 0) {
          if (record.jumboBag > 0) wasteInfo += `${record.bigBag} big, `;
          else wasteInfo += `${record.bigBag} big`;
        }
        if (record.jumboBag > 0) {
          wasteInfo += `${record.jumboBag} jumbo`;
        }
        wasteInfo += ")";
        return (
          <>
            <Row justify="center"> - {Number(record.wasteWeight).toFixed(1)}</Row>
            {(record.smallBag > 0 || record.bigBag > 0 || record.jumboBag > 0) && (
              <Row justify="center" style={{ fontSize: "12px" }}>
                {wasteInfo}
              </Row>
            )}
            {record.other && (
              <Row justify="center" style={{ fontSize: "12px" }}>
                ( Other: {record.other})
              </Row>
            )}
          </>
        );
      },
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      dateIndex: "netWeight",
      align: "center" as const,
      render: (record: any) => {
        if (record === undefined) return;
        return <strong>{Number(record.netWeight).toFixed(1)}</strong>;
      },
    },
    {
      title: "Manual Entry",
      dataIndex: "manualEntry",
      key: "completed",
      align: "center" as const,
      render: (record: any) =>
        record ? (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "orange", marginRight: "5px" }} />
            Yes
          </>
        ) : (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "green", marginRight: "5px" }} />
            No
          </>
        ),
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getSuppliers();
    getMetals();
  }, []);

  useEffect(() => {
    getPurchases(currentPage, suppliersSelectedOptions, dateRangeFilter);
  }, [currentPage]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const getPurchases = async (pageNumber: Number, suppliersFilter: String, dateRangeFilter: String[]) => {
    try {
      setLoading(true);
      const filters = {
        suppliers: suppliersFilter,
        startDate: dateRangeFilter[0] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[0],
        endDate: dateRangeFilter[1] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[1],
      };
      const res = await getPurchasesService(currOffice, String(pageNumber), filters);
      setTotalPages(res.data.totalPages);
      setTotalPurchases(res.data.totalPurchases);
      const updatedPurchases = [...res.data.purchases];
      for (let purchase of updatedPurchases) {
        purchase.key = purchase.purchaseID;
      }
      setPurchasesList(updatedPurchases);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getPurchases error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterial = async (materialID: string) => {
    try {
      const res = await getMaterialService(materialID);
      return res;
    } catch (e: any) {
      console.error("getMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const toggleSmallPurchase = async (record: any, checked: boolean) => {
    console.log(`switch to ${checked}`);
    try {
      setLoading(true);
      const payload = {
        purchaseID: record.purchaseID,
        smallTransaction: checked,
      };
      const res = await toggleSmallPurchaseService(payload);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("toggleSmallPurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSuppliers = async () => {
    try {
      setLoading(true);
      const res = await getSuppliersService();
      const suppliersData =
        currOffice === "pg" ? res.data.pgSuppliers : currOffice === "bw" ? res.data.bwSuppliers : [];
      setSuppliers(suppliersData);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getSuppliers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSuppliersFilterOptions = () => {
    const options: any = [];
    suppliers.forEach((supplier: any) => {
      options.push({
        value: supplier.supplierID,
        label:
          supplier.companyName !== "" && supplier.companyName !== undefined
            ? `${supplier.companyName} ( ${supplier.name} )`
            : `${supplier.name}`,
      });
    });
    setSuppliersOptions(options);
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSupplierDisplayName = (supplierID: string) => {
    const supplierInfo = suppliers.find((supplier: any) => supplier.supplierID === supplierID);
    let supplierDisplayInfo = "";
    if (supplierInfo !== undefined && supplierInfo["companyName"] !== "" && supplierInfo["name"] !== "") {
      supplierDisplayInfo = supplierInfo["companyName"] + " (" + supplierInfo["name"] + ")";
    } else if (supplierInfo !== undefined && supplierInfo["companyName"] !== "") {
      supplierDisplayInfo = supplierInfo["companyName"];
    } else if (supplierInfo !== undefined && supplierInfo["name"] !== "") {
      supplierDisplayInfo = supplierInfo["name"];
    }
    return supplierDisplayInfo;
  };

  const generateBill = async (purchaseID: string, supplierID: string) => {
    try {
      setLoading(true);
      const currPurchase = purchasesList.find((purchase: any) => purchase.purchaseID === purchaseID);
      const payload = {
        purchaseCreatedTimestamp: currPurchase.createdTimestamp,
        smallTransaction: currPurchase.smallTransaction,
        purchaseID: purchaseID,
        supplierID: supplierID,
        totalNetWeight: currPurchase.totalNetWeight,
        totalNumMaterials: currPurchase.totalNumMaterials,
        office: currPurchase.office,
      };
      const res = await postBillService(payload);
      setLoading(false);
      navigate(`/bill/${res.data.billID}`);
    } catch (e: any) {
      setLoading(false);
      console.error("generateBill error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const formatPurchaseSupplierFileName = (supplierID: string, purchaseID: string) => {
    const supplierInfo: any = suppliers.find((supplier: any) => supplier.supplierID === supplierID);
    const supplierName = supplierInfo.companyName ? supplierInfo.companyName : supplierInfo.name;
    return `purchase_${supplierName}_${purchaseID}.pdf`.replaceAll(" ", "_");
  };

  const printPurchase = async (purchaseDetails: any) => {
    try {
      setLoading(true);
      const fileName = formatPurchaseSupplierFileName(purchaseDetails.supplierID, purchaseDetails.purchaseID);
      const res = await getPurchasePDF(fileName);
      setPrintPurchaseData(res.data);
      setIsPDFModalOpen(true);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("printPurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const closePDFModal = () => {
    setIsPDFModalOpen(false);
  };

  const isTimestampMoreThan2Hours = (timestamp: any) => {
    const createdMilliseconds = new Date(timestamp).getTime();
    const currentTimeMilliseconds = new Date().getTime();
    return currentTimeMilliseconds - createdMilliseconds > 7776000000 ? true : false;
  };

  const getPurchaseExpandedDetails = async (purchaseInfo: any) => {
    try {
      setLoading(true);
      const currPurchase = purchasesList.find((purchase: any) => purchase.purchaseID === purchaseInfo.purchaseID);
      const currMaterials: any[] = [];
      for (let materialID of currPurchase.materialIDList) {
        const resMaterial: any = await getMaterial(materialID);
        const materialData = resMaterial.data;
        const currMetal: any = metals.find((metal: any) => metal.metalID === materialData.metalID);
        materialData.displayName = currMetal.displayName;
        materialData.key = materialData.materialID;
        currMaterials.push(materialData);
      }
      const newPurchaseDetails = [...purchaseDetailsTableData];
      const newPurchaseDetailsObject = {
        purchaseID: purchaseInfo.purchaseID,
        materialsList: currMaterials,
      };
      newPurchaseDetails.push(newPurchaseDetailsObject);
      setPurchaseDetailsTableData([...newPurchaseDetails]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getPurchaseExpandedDetails error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const displayPurchaseDetails = (purchaseID: string) => {
    const currPurchase = purchasesList.find((purchase: any) => purchase.purchaseID === purchaseID);
    const currPurchaseDetails = purchaseDetailsTableData.find((purchase: any) => purchase.purchaseID === purchaseID);
    return (
      <>
        <Row justify="center">
          <Col span={20}>
            <Table
              dataSource={[...currPurchaseDetails.materialsList]}
              columns={purchaseDetailsColumns}
              pagination={false}
            />
          </Col>
        </Row>
        <Row>
          <strong style={{ marginRight: "10px" }}>Purchase ID: </strong> {currPurchaseDetails.purchaseID}
        </Row>
        {currPurchase.notes && (
          <>
            <Row style={{ margin: "10px 0" }}>
              <strong>Notes</strong>
            </Row>
            <Row>{currPurchase.notes}</Row>
          </>
        )}
      </>
    );
  };

  const openDeletePurchaseModal = (record: any) => {
    setPurchaseToDelete(record);
    setIsDeleteModalOpen(true);
  };

  const confirmDeletePurchase = async () => {
    setIsDeleteModalOpen(false);
    await deletePurchase(purchaseToDelete.purchaseID);
    await getPurchases(currentPage, suppliersSelectedOptions, dateRangeFilter);
  };

  const deletePurchase = async (purchaseID: string) => {
    try {
      setLoading(true);
      const res = await deletePurchaseService(purchaseID, currOffice);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("deletePurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const declineDeletePurchase = () => {
    setPurchaseToDelete({});
    setIsDeleteModalOpen(false);
  };

  const openPurchaseOutUploadModal = (purchaseID: string) => {
    setPurchaseOutUploadModal(true);
    setPurchaseIDForPurchaseOutUpload(purchaseID);
  };

  const editPurchase = (record: any) => {
    navigate(`/purchase/${record.purchaseID}`);
  };

  const printPurchasePDF = () => {
    printJS({ printable: encodeURI(printPurchaseData), type: "pdf", base64: true });
  };

  const confirmFilterMaterials = async () => {
    setIsFilterModalOpen(false);
    await getPurchases(1, suppliersSelectedOptions, dateRangeFilter);
    setIsFilteredData(true);
  };

  const cancelFilterMaterials = () => {
    setIsFilterModalOpen(false);
  };

  const cancelPurchaseOutUpload = () => {
    setPurchaseOutUploadModal(false);
    setPurchaseIDForPurchaseOutUpload("");
    setUploadDisable(false);
  };

  const openFilterModal = () => {
    getSuppliersFilterOptions();
    setIsFilterModalOpen(true);
  };

  const resetFilters = async () => {
    setSuppliersSelectedOptions("");
    setDateRangeFilter([]);
    setDateRangeValue([null, null]);
    await getPurchases(1, "", []);
    setIsFilterModalOpen(false);
    setIsFilteredData(false);
  };

  const updateSupplierFilter = (value: any) => {
    setSuppliersSelectedOptions(value);
  };

  const getSelectedSuppliersValue = () => {
    if (suppliersSelectedOptions === "") return [];
    return suppliersSelectedOptions;
  };

  const updateDateRangeFilter = (dateRange: string[]) => {
    setDateRangeValue([dayjs(dateRange[0], "YYYY-MM-DD"), dayjs(dateRange[1], "YYYY-MM-DD")]);
    setDateRangeFilter(dateRange);
  };

  const uploadPurchaseOutImages = async () => {
    try {
      setLoading(true);
      console.log("purchaseOutImagesList", purchaseOutImagesList);
      let payload: any = {
        fileList: purchaseOutImagesList,
      };
      console.log("payload", payload);
      // const formData = new FormData();
      // formData.append("myFile", selectedFile, selectedFile.name);
      // console.log("formData", formData);
      // console.log("selectedFile", selectedFile);
      // console.log("selectedFile", selectedFile.name);
      // let payload: any = {
      //   file: selectedFile,
      // };
      const res = await postUploadPurchaseOutImagesService(purchaseIDForPurchaseOutUpload, payload);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("uploadPurchaseOutImages error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const convertBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row justify="start">
              <Col span={12}>
                <h2 className="purchases-title">Purchases</h2>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Button
                    type="default"
                    onClick={() => openFilterModal()}
                    icon={<FilterOutlined />}
                    style={{
                      marginTop: "20px",
                      marginRight: "10px",
                      color: isFilteredData ? "white" : "",
                      backgroundColor: isFilteredData ? "#283555" : "",
                    }}
                  ></Button>
                  <Button
                    type="default"
                    onClick={() => {
                      resetFilters();
                    }}
                    icon={<ReloadOutlined />}
                    style={{ marginTop: "20px" }}
                  >
                    Reload Data
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Table
              className="purchases-table"
              dataSource={[...purchasesList]}
              columns={purchaseColumns}
              pagination={{
                pageSize: 20,
                total: totalPurchases,
                showSizeChanger: false,
                onChange: (page) => {
                  setCurrentPage(page);
                  getPurchases(page, suppliersSelectedOptions, dateRangeFilter);
                },
              }}
              expandedRowRender={(record) => displayPurchaseDetails(record.purchaseID)}
              expandIcon={({ expanded, onExpand, record }) =>
                expanded ? (
                  <Button type="default" size="small" onClick={(e) => onExpand(record, e)}>
                    Hide Details
                  </Button>
                ) : (
                  <Button
                    type="default"
                    size="small"
                    onClick={async (e) => {
                      await getPurchaseExpandedDetails(record);
                      onExpand(record, e);
                    }}
                  >
                    Show Details
                  </Button>
                )
              }
            />
          </Col>
        </Row>
        <Copyright />
      </Content>
      <Modal
        title="Delete Purchase"
        open={isDeleteModalOpen}
        okText="Confirm Delete"
        okType="danger"
        onOk={confirmDeletePurchase}
        onCancel={declineDeletePurchase}
      >
        <p>
          Are you sure you want to delete this purchase from{" "}
          <strong>{getSupplierDisplayName(purchaseToDelete.supplierID)}</strong> on{" "}
          <strong>{new Date(purchaseToDelete.createdTimestamp).toLocaleDateString("en-GB")}</strong>?
        </p>
        <p>This will permanently delete this purchase and this action cannot be undone.</p>
      </Modal>
      <Modal
        title="Purchase PDF"
        style={{ height: "600px" }}
        open={isPDFModalOpen}
        okText="Print"
        onOk={printPurchasePDF}
        onCancel={closePDFModal}
      >
        <iframe
          title="printBill"
          id="printBill"
          src={`data:application/pdf;base64, ${encodeURI(printPurchaseData)}`}
          height="500px"
          width="100%"
        ></iframe>
      </Modal>
      <Modal
        title="Filter Purchases"
        open={isFilterModalOpen}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={cancelFilterMaterials}
      >
        <Row>
          <Col span={24}>
            <Row style={{ marginBottom: "10px" }}>Suppliers:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <Select
                showSearch
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                placeholder="Select suppliers"
                value={getSelectedSuppliersValue()}
                onChange={updateSupplierFilter}
                options={suppliersOptions}
                filterOption={(input: any, option: any) => {
                  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
              />
            </Row>
            <Row style={{ marginBottom: "10px" }}>Date Range:</Row>
            <Row style={{ marginBottom: "10px" }}>
              <RangePicker
                style={{ width: "100%" }}
                // defaultValue={[null, null]}
                // value={[null, null]}
                value={dateRangeValue}
                onChange={(value, dateString: string[]) => {
                  updateDateRangeFilter(dateString);
                }}
                disabledDate={(current) => {
                  let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                  return current && current > moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Row>
            <Row justify="center" style={{ margin: "30px 0" }}>
              <Button onClick={() => resetFilters()} style={{ marginRight: "20px" }}>
                Reset Filters
              </Button>
              <Button type="primary" onClick={() => confirmFilterMaterials()}>
                Filters Purchases
              </Button>
            </Row>
          </Col>
        </Row>
      </Modal>
      <Modal
        title="Upload Purchase Out Images/Files "
        open={purchaseOutUploadModal}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={cancelPurchaseOutUpload}
      >
        <Row>
          <Col span={24} style={{ margin: "50px 0" }}>
            <Dragger
              name="file"
              multiple={true}
              onChange={async (info: any) => {
                setUploadDisable(false);
                console.log("onchange function");
                console.log("info", info);
                const isImageType =
                  info.file.type === "image/png" ||
                  info.file.type === "image/jpg" ||
                  info.file.type === "image/jpeg" ||
                  info.file.type === "application/pdf";
                if (!isImageType) {
                  // message.error(`${info.file.name} is not a png, jpeg or pdf file`);
                  setUploadDisable(true);
                  return;
                }
                if (
                  info.file.type === "image/png" ||
                  info.file.type === "image/jpg" ||
                  info.file.type === "image/jpeg"
                ) {
                  let imageFile = info.file.originFileObj;
                  console.log("info.file", info.file.originFileObj);
                  const base64 = await convertBase64(imageFile);
                  let currFileList = [...purchaseOutImagesList];
                  currFileList.push({ type: "image", base64: base64 });
                  setPurchaseOutImagesList(currFileList);
                } else if (info.file.type === "application/pdf") {
                  // let imageFile = info.file.originFileObj;
                  // console.log("info.file", info.file.originFileObj);
                  // const base64 = await convertBase64(imageFile);
                  // let currFileList = [...purchaseOutImagesList];
                  // currFileList.push({ type: "pdf", base64: base64 });
                  // setPurchaseOutImagesList(currFileList);
                }
              }}
              onDrop={async (e: any) => {
                console.log("Dropped files", e);
                const file = e.dataTransfer.files[0];
                console.log("files", file);
                // const base64 = await convertBase64(file);
                // let currFileList = [...purchaseOutImagesList];
                // currFileList.push(base64);
                // setPurchaseOutImagesList(currFileList);
              }}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file to this area to upload</p>
            </Dragger>
          </Col>
        </Row>
        <Row justify="center" style={{ margin: "30px 0" }}>
          <Button onClick={() => cancelPurchaseOutUpload()} style={{ marginRight: "20px" }}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => uploadPurchaseOutImages()} disabled={uploadDisable}>
            Upload Images
          </Button>
        </Row>
      </Modal>
    </Layout>
  );
};

export default PurchasesPage;
